































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
 
class PageRblistupnotdataRequest extends PageRequest {
  Keyword: string;
  isrent: number; //nullable
  stime: Date;
  etime: Date;
  atype:number;
  areaid:number;
  qid:number;
  sid:number;
  cid:number;
  vid:number;
}

 @Component({
        components:{}
    })
export default class Rblistupnotdata extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageRblistupnotdataRequest = new PageRblistupnotdataRequest();
  creationTime: Date[] = [];

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get list() {
     
    return this.$store.state. rblistupnotdata.list;
  }
  get loading() {
   
    return this.$store.state. rblistupnotdata.loading;
  }
  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("rblistupnotdata/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("rblistupnotdata/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

     if (this.creationTime.length > 0) {
      this.pagerequest.stime = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      
      this.pagerequest.etime = this.creationTime[1];
    }

    if(this.pagerequest.vid>0){
       this.pagerequest.areaid=this.pagerequest.vid;
       this.pagerequest.atype=4;
    }else if(this.pagerequest.cid>0){
       this.pagerequest.areaid=this.pagerequest.cid;
       this.pagerequest.atype=3;
    }
    else if(this.pagerequest.sid>0){
       this.pagerequest.areaid=this.pagerequest.sid;
       this.pagerequest.atype=2;
    }
   else  if(this.pagerequest.qid>0){
       this.pagerequest.areaid=this.pagerequest.qid;
       this.pagerequest.atype=1;
    }

    await this.$store.dispatch({
      type: "rblistupnotdata/getAll",
      data: this.pagerequest,
    });
    
  }
   
   
 

  get pageSize() {
    return this.$store.state. rblistupnotdata.pageSize;
  }
  get totalCount() {
    return this.$store.state. rblistupnotdata.totalCount;
  }
  get currentPage() {
    return this.$store.state. rblistupnotdata.currentPage;
  }

  columns = [
    {
     
      title: this.L("用户姓名"),
      key: "username",
    },
      {
      title: '城市/区',
      render: (h: any, params: any) => {
        
        return h("span", params.row.cityname+'-'+params.row.disname);
      },
    },
    {
      title: '街道',
      key: "streetname",
    },
      {
      title: '社区',
      key: "comname",
    },

    {
      title: this.L("小区"),
       key: "vilname",
    },
     
     {
      
      title: this.L("详细地址"),
      key: "useraddr",
    }
     
    
    
    

      
  ];
  async created() {
    this.getpage();
    this.getAreaAll();
     
  }

 async getAreaAll() {
    await this.$store.dispatch({
      type: "rblistupnotdata/getQAreaAllData",
    });
  }
  //获取初始值
    get qarealist(){
          
            return this.$store.state.rblistupnotdata.qarea;
     }
      //区下面的街道
       get qarealst(){
           return this.$store.state.rblistupnotdata.qarealst;
       }
       set qarealst(val:number){
            this.$store.commit('rblistupnotdata/change_qarealst',val);
       }
       //街道的社区
       get sarealst(){
            return this.$store.state.rblistupnotdata.sarealst;
       }
       set sarealst(val:number){
          this.$store.commit('rblistupnotdata/change_sarealst',val);           
        
       }
       //社区下的小区
      get carealst(){

            return this.$store.state.rblistupnotdata.carealst;
       }
       set carealst(val:number){
          this.$store.commit('rblistupnotdata/change_carealst',val);           
        
       }
       
     QAreaChange(val:number){
        
        this.pagerequest.qid=val;
       
         
     var dt= this.$store.state.rblistupnotdata.qarea;
        dt.forEach(item=>{
        if(item.id==val){
               this.qarealst=item;
            }
          })
            
       }
      SAreaChange(val:number){
       this.pagerequest.sid=val;
       var dt= this.$store.state.rblistupnotdata.qarealst.sAreas;
     dt.forEach(item=>{
        if(item.id==val){
         this.sarealst=item;
        }
    })
      }
     CAreaChange(val:number){
         this.pagerequest.cid=val;
       var dt= this.$store.state.rblistupnotdata.sarealst.cAreas;
    dt.forEach(item=>{
    if(item.id==val){
         this.carealst=item;
        }
    })
   }
      VAreaChange(val:number){
         this.pagerequest.vid=val;
         
         }
 


  //导出
   async  exportExcel() {
   
     this.pagerequest.maxResultCount = 999999999;
     this.pagerequest.skipCount =0;
     let lt= await this.$store.dispatch({
      type: "rblistupnotdata/getAllexportExcel",
      data: this.pagerequest,
    });
 
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
				   
					lt.map((item) => { // 这里修改要下载的字段内容
        
        	          item.citynamedisname=item.cityname+'-'+item.disname;
					  return item;
					});
    
					const filterVal = ['username','citynamedisname','streetname' ,'comname', 'vilname', 'useraddr'];// 取出要下载的表头字段
					const tHeader = ['用户姓名','城市/区','街道','社区','小区','详细地址'];// 把表头字段定义成想要的中文或英文
					const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '垃圾未上传统计');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}

}
